export enum StorageModes {
  AzureBlob = "AzureBlob",
  AWSS3 = "AWSS3",
  FTP = "FTP",
  SFTP = "SFTP",
  Ceph = "Ceph"
}
